export const orderRequest = ({
    address,
    nameCustomer,
    emailCustomer,
    phoneNumberCustomer,
    totalPrice = 0,
    deliveryFee = 0,
    orderStatus,
    deliveryStatus,
    deliveryMethod,
    coupondCode = "",
    rejectReason = "",
    listOrderDetails = [],
} = {}) => ({
    address,
    nameCustomer,
    emailCustomer,
    phoneNumberCustomer,
    totalPrice,
    deliveryFee,
    orderStatus,
    deliveryStatus,
    deliveryMethod,
    coupondCode,
    rejectReason,
    listOrderDetails,
});